import { logToken } from '../../api/log_token';
import { IPhone } from '../../api/offer';

import { ca } from '@cian/analytics';

const makeUrl = (...parts: string[]) => '/' + parts.join('/');

interface IGeo {
  region: number;
  city: number;
}

interface ISerpObjectDetailOpenEvent {
  action: string;
  bsCenterId: number;
  listingType: 'BC' | 'TC' | 'WC';
  trackingProduct: ISerpObjectPhoneOpenProduct | undefined;
}

interface ISerpOfferDetailOpenEvent {
  offerId: number;
  listingType: 'BC' | 'TC' | 'WC';
}

interface ISerpObjectPhoneOpenEvent {
  id: number;
  bsCenterId: number;
  bsCenterType: 'BC' | 'TC' | 'WC';
  geo: IGeo;
  representativeType: 'none' | 'agent' | 'company';
  fromDeveloper: boolean;
  offrepExists: boolean;
  phones: IPhone[];
  trackingProduct?: ISerpObjectPhoneOpenProduct;
}

interface ISerpObjectPhoneOpenProduct {
  id: number;
  category: string;
  brand: string;
  variant: string;
  price: number;
  quantity: 1;
}

function trackingSerpObjectDetailOpen(e: ISerpObjectDetailOpenEvent) {
  // tslint:disable-next-line:no-any
  const trackingEvent: any = {
    name: 'oldevent',
    category: 'Listing',
    action: e.action,
    label: `card_${e.listingType}`,
    'listing-type': `listing-${e.listingType}`,
  };

  // tslint:disable-next-line:no-any
  const dataLayerBackedObject = (window as any)._dataLayerBackedObject;

  if (dataLayerBackedObject) {
    trackingEvent.page = { ...dataLayerBackedObject.page };
    trackingEvent.user = { ...dataLayerBackedObject.user };
    trackingEvent.searchConditions = { ...dataLayerBackedObject.searchConditions };
    trackingEvent.partner = { ...dataLayerBackedObject.partner };

    if (e.trackingProduct && Array.isArray(dataLayerBackedObject.products)) {
      // tslint:disable-next-line:no-any
      const product = dataLayerBackedObject.products.find((product: any) => product.id === e.trackingProduct.id);

      if (product) {
        trackingEvent.products = [product];
      }
    }
  }

  ca('eventSite', trackingEvent);
}

function trackingSerpOfferDetailOpen(e: ISerpOfferDetailOpenEvent) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card',
    label: 'card_detail',
    'listing-type': `listing-${e.listingType}`,
  });
}

function trackingSerpObjectPhoneOpen(e: ISerpObjectPhoneOpenEvent, token?: string) {
  const pseudoUrl = makeUrl(
    e.bsCenterType,
    'commercial',
    'mo_id=0',
    `obl_id=${e.geo.region}`,
    `city_id=${e.geo.city}`,
    `object_type=`,
    'ga_obj_type=0',
    `spec=${e.representativeType}`,
    `${e.bsCenterId}`,
    `from_developer=${Number(e.fromDeveloper)}`,
    `repres=${Number(e.offrepExists)}`,
    'owner=0',
  );

  // tslint:disable-next-line:no-any
  let trackingEvent: any = {
    name: 'oldevent',
    category: 'Phones',
    action: `Open-listing_${e.bsCenterType}`,
    label: pseudoUrl,
    'listing-type': `listing-${e.bsCenterType}`,
    // tslint:disable:no-any
    page: { ...(window as any)._dataLayerBackedObject.page },
    user: { ...(window as any)._dataLayerBackedObject.user },
    searchConditions: (window as any)._dataLayerBackedObject.searchConditions,
    partner: { ...(window as any)._dataLayerBackedObject.partner },
    // tslint:enable:no-any
  };

  if (e.trackingProduct) {
    // tslint:disable:no-any
    const product = (window as any)._dataLayerBackedObject.products
    .find((product: any) => product.id === e.trackingProduct.id);

    trackingEvent.products = [product];
  }

  ca('eventSite', trackingEvent);

  if (token) {
    logToken(token);
  }
}

function trackingSerpChangeConditions(e: { listingType: 'BC' | 'TC' | 'WC' }) {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'change_conditions',
    'listing-type': `listing-${ e.listingType }`,
  });
}

function trackingSerpShowNotFound() {
  ca('event', {
    name: 'oldevent',
    category: 'subscription',
    action: 'Open',
    label: 'From_Empty_BC_Listing',
  });
}

export {
  ISerpObjectDetailOpenEvent,
  ISerpObjectPhoneOpenEvent,
  ISerpObjectPhoneOpenProduct,
  ISerpOfferDetailOpenEvent,
  trackingSerpChangeConditions,
  trackingSerpObjectDetailOpen,
  trackingSerpObjectPhoneOpen,
  trackingSerpOfferDetailOpen,
  trackingSerpShowNotFound
};



// WEBPACK FOOTER //
// ./src/bundles/business_shopping_centers_serp/tracking.ts